<!-- Ported from the Polaris kit: src/components/ui/sidebar/SidebarSeparator.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';
import { Separator } from '../separator';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <Separator
    data-slot="sidebar-separator"
    data-sidebar="separator"
    :class="cn('bg-polaris-sidebar-border mx-2 w-auto', props.class)"
  >
    <slot />
  </Separator>
</template>
